import React from 'react';
import Modal from 'react-modal';

import './HomeTeamModal.css'; // Import custom CSS for styling

const HomeTeamModal = ({
  licenseTeam,
  oppTeam,
  isOpen,
  onRequestClose,
  setSelectedHomeTeam,
  setSelectedVisitorTeam,
  setSelectedTeam,
}) => {
  const handleSelect = (teamType, val) => {
    if (setSelectedTeam) {
      if (teamType === 'licenseTeam') {
        setSelectedTeam('teamA');
      }
      if (teamType === 'oppTeam') {
        setSelectedTeam('teamB');
      }
      setSelectedHomeTeam(val);
      if (teamType === 'licenseTeam') {
        setSelectedVisitorTeam(oppTeam.teamName);
      }
      if (teamType === 'oppTeam') {
        setSelectedVisitorTeam(licenseTeam.teamName);
      }
    } else {
      setSelectedHomeTeam(val);
      if (teamType === 'licenseTeam') {
        setSelectedVisitorTeam(oppTeam.teamName);
      }
      if (teamType === 'oppTeam') {
        setSelectedVisitorTeam(licenseTeam.teamName);
      }
    }
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modalView"
      overlayClassName="modalOverlay"
    >
      <div className="modalContent">
        <h2 className="selectHomeTxt">Select Home Team:</h2>
        <button
          onClick={() => handleSelect('licenseTeam', licenseTeam)}
          className="homeTeamBtn"
        >
          {licenseTeam?.teamName}
        </button>
        <button
          onClick={() => handleSelect('oppTeam', oppTeam)}
          className="homeTeamBtn"
        >
          {oppTeam?.teamName}
        </button>
      </div>
    </Modal>
  );
};

export default HomeTeamModal;
